import { utils } from '@ps/web-poker-tile-mappers';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import type { InfoItemProps } from '../../InfoItem/InfoItem';
import WinnerItem from '../../WinnerItem/WinnerItem';
import type { InfoItemsProps } from '../InfoItemsContainer';
import InfoItemsList from '../InfoItemsList';
import {
  getPrizePoolFirstPrizeItem,
  getPrizePoolItem,
  getTimeItemCompleted,
  getTotalPlayersItem,
  getWinnerAward,
  hasStartTime
} from '../utils';

import { TXTCLI_Places_paid } from './InfoItemsCompleted.messages.json';
import styles from './InfoItemsCompleted.scss';

const InfoItemsCompleted: React.FC<InfoItemsProps> = ({ tournament, timesData }) => {
  const intl = useIntl();
  const timeZone = useSelector(select.timeZone.getTimeZoneName);
  const isPrizeRealMoney = utils.mttUtils.isPrizePoolRealMoney(tournament.prizePoolUnit);
  const infoItems: InfoItemProps[] = [];
  if (hasStartTime(tournament)) {
    infoItems.push(getTimeItemCompleted(timesData, timeZone, intl));
  }
  const winnerAward = getWinnerAward(tournament, intl);

  if (isPrizeRealMoney) {
    infoItems.push(getPrizePoolFirstPrizeItem(tournament, intl));
  } else {
    infoItems.push(getPrizePoolItem(tournament));
  }
  infoItems.push(getTotalPlayersItem(tournament, intl));

  return (
    <>
      <InfoItemsList infoItems={infoItems} />
      {tournament.winner && (
        <>
          <WinnerItem
            prizePoolUnit={tournament.prizePoolUnit}
            winner={tournament.winner}
            winnerAward={winnerAward}
          />
          {tournament.paidPlaces > 0 && (
            <div className={styles.paidPlaces}>
              <span className={styles.label}>
                <Translation {...TXTCLI_Places_paid} />
              </span>
              <span className={styles.value}>{intl.formatNumber(tournament.paidPlaces)}</span>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default InfoItemsCompleted;
